export default [
  {
    type: "image",
    label: "Imagem",
    icon: "ph ph-image"
  },
  {
    type: "video",
    label: "Vídeo",
    icon: "ph ph-video"
  },
  {
    type: "text",
    label: "Texto",
    icon: "ph ph-text-t"
  },
  // {
  //   type: "image-text",
  //   label: "Imagem e Texto",
  //   icon: ["ph ph-image", "ph ph-text"]
  // },
  {
    type: "timer",
    label: "Cronômetro",
    icon: "ph ph-clock-countdown"
  }
  // {
  //   type: "rating",
  //   label: "Avaliação",
  //   icon: "ph ph-star"
  // }
];
